<template>
    <div class="cart-view">
        <CartItemView v-for="(cart,index) in carts" :key="cart.id" :cart='cart' :isChecked='selectList[index]' :index="index" @onChangeChecked=' onItemCheckedChange'> </CartItemView>
        <van-submit-bar :price="totalPrice" button-text="提交订单" @submit="onSubmit">
            <van-checkbox v-model="isAll" class="all-checkbox" checked-color="#07c160">全選</van-checkbox>
        </van-submit-bar>
    </div>
</template>
<script>
    import { Checkbox, SubmitBar } from 'vant';
    import CartItemView from '../cartItemView/cartItemView.vue'
    export default {
        name: "cartView",
        components: {
            CartItemView,
            [Checkbox.name]: Checkbox,
            [SubmitBar.name]: SubmitBar,
        },
        data() {
            return {
                title: "購物車",
                navViewShow: true,
                carts: null,
                isAll: false,
                selectList: []
            };
        },
        methods: {
            onSubmit: function () { console.log('提交訂單') },
            onItemCheckedChange: function (isChecked, index) {
                // console.log(isChecked, index)
                // 更新狀態數組
                // this.selectList[index] = isChecked;
                // console.log(this.selectList);
                this.$set(this.selectList, index, isChecked)
            },
            // 全选点击的方法处理
            onCheckAll: function () {
                for (var i = 0; i < this.selectList.length; i++) {    // 遍历selectList数组
                    // 以下方法，数组虽然是更新的，但界面是不会跟随跟新的                        
                    // this.selectList[i] = this.isAll
                    // 这就需要使用到 Vue.set 方法来处理这个数组
                    this.$set(this.selectList, i, this.isAll)
                }
            }
        },
        created() {
            // console.log(this.title);
            // 創建時，發送標題
            this.$emit("onTitle", this.title);
            this.$emit("onNavShow", this.navViewShow);
            var that = this;
            this.$ajax.get("/json/cart.json").then(function (response) {
                // console.log(response.data)
                that.carts = response.data;
                //動態添加商品
                for (var i = 0; i < that.carts.length; i++) {
                    that.selectList.push(true)
                }
            });
        },
        computed: {
            totalPrice: function () {
                var total = 0
                for (var i = 0; i < this.selectList.length; i++) {
                    if (this.selectList[i]) {//選中才計算
                        var price = this.carts[i].price
                        var num = this.carts[i].num
                        total += price * num
                    }
                }
                //注意單位(分轉換成元)
                return total * 100
            },
        },
    };
</script>
<style lang='scss'>
    .cart-view {
        padding-top: 45px;
        box-sizing: border-box;
        .van-submit-bar {
            bottom: 50px;
            .all-checkbox {
                margin-left: 15px;
            }
        }
    }
</style>
